<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<p class="dedi1">To</p>
<p class="dedi">SYLVIA and STIRLING PARKINSON</p>
<p class="dedi">in appreciation of much that is</p>
<p class="dedi">pleasant to remember</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03_Dedi.vue?3672a7d0